import React, { useState } from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const ModalOxxoType = ({ callback, imgOne, imgTwo }) => {
	const [img, setimg] = useState(0)

	const check = () => {
		if (img === 2) {
			callback()
		}
		else {
			setimg(2)
		}
	}
	return (
		<div className='fixed z-30 bottom-0 h-full w-full '>
			<div className=' w-full h-full flex justify-center items-center p-[12px] md:px-[32px] md:pb-[75px]'>
				<img src={img === 0 ? imgOne : imgTwo} className="h-full w-full object-contain" alt="" ></img>
			</div>
			<div onClick={() => {
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
				check()
			}} className="boxShadowButtons fixed z-30 bottom-3 right-4 h-[35px] w-[150px] md:h-[48px] md:w-[268px] rounded-2xl bg-yellow_primary flex justify-center items-center">
				<span className="text-white text-[14px] md:text-[24px]">Continuar</span>
			</div>
		</div>
	);
};